<template>
	<q-field :error="invalid" :error-label="errorMsg" style="position: relative">
		<select v-if="enableTouchFix" v-model="val" style="width: 100%; position: absolute; z-index: 99999; opacity: 0; padding-bottom: 20px;">
			<option></option>
			<option v-for="opt in options" :value="opt.value" :key="opt.value">
				{{ opt.label }}
			</option>
		</select>
		<q-select
			:tabindex="tabIndex"
			:disable="enableTouchFix"
			:dark="dark"
			color="secondary"
			:float-label="label"
			v-model="val"
			:options="options"
		/>
	</q-field>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import config from '@/models/services/config';

@Component

export default class CustomSelect extends Vue {
	/**
	 * Provides a Q-Select, with a custom fallback to native behavior for touch devices
	 *
	 * @remarks
	 * A bug present in Quasar v. <= 0.17.16 causes iOS clients in iframes to jump erratically
	 * when Q-Select elements are interacted with.
	 */
	@Prop() public value!: any;
	@Prop() public label!: string;
	@Prop() public errorMsg!: string;
	@Prop() public options!: any[];
	@Prop() public invalid!: boolean;
	@Prop() public validating!: boolean;

	private get dark() {
		return config.Dark;
	}

	public get val() {
		return this.value;
	}

	public set val(val: any) {
		this.$emit('change', val);
	}

	public get enableTouchFix() {
		const quasar = (this as any).$q;

		return quasar.platform.has.touch
			&& quasar.platform.within.iframe
			&& quasar.platform.is.ios;
	}

	public get tabIndex() {
		return this.enableTouchFix ? -1 : 0;
	}
}
</script>
